var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.orders.length === 0)?_c('p',[_vm._v("You do not currently have any order history.")]):_vm._e(),(_vm.orders.length > 0)?_c('OrdersGrid',{attrs:{"orders":_vm.orders}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }